import React from 'react';
import PropTypes from 'prop-types';
import infoIcon from '../../../assets/icons/info.svg';
import HtmlTooltip from '../ToolTip/ToolTip';

import './Table.scss';

interface HeaderInfoCellProps {
  text: string;
  infoText: string;
}

function HeaderInfoCell({ text, infoText }: HeaderInfoCellProps) {
  return (
    <div className="common_table_header_info_cell">
      {text}
      {infoText && (
      <HtmlTooltip
        title={
            (
              <>
                <span>{infoText}</span>
              </>
            )
        }
      >
        <img className="info_icon" src={infoIcon} alt="" />
      </HtmlTooltip>
      )}
    </div>
  );
}

HeaderInfoCell.defaultProps = {
  infoText: '',
};

HeaderInfoCell.propTypes = {
  text: PropTypes.string.isRequired,
  infoText: PropTypes.string,
};

export default HeaderInfoCell;
